<template>
  <dialog-email
    :isLoading="isLoading"
    ref="dialogEmail"
    :contentKey="contentKey"
    :contentMap="contentMap"
    :data="emailData"
    @on-submit-email="onSubmitEmail"
  >
  </dialog-email>
</template>

<script>

import { toDate } from '@/utils/filters'
import { ServiceRFQ2s } from '@/services/RFQ2s'
import { ServiceEmailMessages } from '@/services/email-messages'
import { ServiceSalesOrders } from '@/services/SalesOrders'
import { equals, makeFilter, select } from '@/utils/dynamic'

export default {
  name: 'SendEmailWrap',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialog' */ '@/components/Dialogs/DialogEmail/index')
  },
  props: {
    rfqUID: { required: true },
    rfqid: { required: true },
    salesOrderID: { required: true },
    supplierCompanyID: { required: true }
  },
  data () {
    return {
      isSendPO: true,
      isLoading: false,
      dataSalesOrder: {},
      dataRFQ2: {},
      emailData: {},
      contentMap: {},
      logoType: null
    }
  },
  computed: {
    contentKey () {
      return this.isSendPO ? 'po-email' : 'wo-email'
    },
    subject () {
      const { baxPO } = this.dataSalesOrder
      const labelKey = this.isSendPO ? 'purchase-order' : 'work-order'
      return `${this.L10n(labelKey)}: ${baxPO || ''}`
    }
  },
  methods: {
    onSubmitEmail (data) {
      return this.sendEmail(data)
    },
    async sendEmail (emailData) {
      this.isLoading = true

      const payload = {
        id: this.rfqUID,
        salesOrderID: this.salesOrderID,
        logoKey: this.logoType,
        translate: this.L10n,
        baxpo: this.dataSalesOrder.baxPO,
        ...emailData
      }

      try {
        this.isSendPO
          ? await ServiceEmailMessages.sendPo(payload)
          : await ServiceEmailMessages.sendWo(payload)
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
        this.hide()
      }
    },
    show ({ isSendPO, logoType } = {}) {
      this.isSendPO = !!isSendPO
      this.logoType = logoType
      this.isLoading = true
      this.$refs.dialogEmail.show()
      this.loadData()
        .then(() => {
          this.createData()
        })
        .catch((err) => {
          this.hide()
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    createData () {
      const { supplierContactName, supplierContactEmail, paymentTerm } = this.dataRFQ2
      const { baxPO, entryDate, forwarderShipperName, forwarderAccountNumber, priority, notes } = this.dataSalesOrder
      const emailToList = []
      supplierContactEmail && emailToList.push(supplierContactEmail)
      this.contentMap = {
        supplierContactName,
        baxPO,
        entryDate: toDate(entryDate),
        paymentTerm,
        forwarderShipperName,
        forwarderAccountNumber,
        priority,
        notes
      }
      this.emailData = {
        emailToList,
        subject: this.subject
      }
    },
    hide () {
      this.logoType = null
      this.$refs.dialogEmail.hide()
    },
    loadData () {
      this.$emit('data-load')
      return this._loadDataSalesOrder()
        .then(() => {
          return this._loadDataRFQ2()
        })
        .finally(() => {
          this.$emit('end-data-load')
        })
    },
    async _loadDataSalesOrder () {
      const { data } = await ServiceSalesOrders.getDynamic(this.salesOrderID, {
        select: select(
          'id', 'entryDate', 'priority.title as priority', 'baxpo as baxPO', 'remarks as notes',
          'shipViaForwarder.accountNumber as forwarderAccountNumber', 'shipViaForwarder.shipper.shipperName as forwarderShipperName')
      })
      this.dataSalesOrder = data
    },
    async _loadDataRFQ2 () {
      const { data } = await ServiceRFQ2s.getByRFQID(this.rfqid, {
        filter: makeFilter('supplierCompanyID', this.supplierCompanyID, equals),
        select: select('id', 'supplierContact.name as supplierContactName', 'supplierContact.email as supplierContactEmail', 'paymentTerm.title as paymentTerm')
      })

      this.dataRFQ2 = data
    }
  }
}
</script>
